import { Button, Dropdown } from "antd";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import deleteIcon from "../../assets/images/delete_icon.png";
import editIcon from "../../assets/images/edit_icon.png";

const StatusComponent = ({
  record,
  handleEdit,
  setDeleteModal,
  handleActive,
  title = "",
  active = "active",
  delivary_status = false,
}) => {
  const onClickDelete = () => {
    if (title) {
      setDeleteModal({
        id: record._id,
        status: true,
        [title]: record?.[title],
      });
    } else {
      setDeleteModal({ id: record._id, status: true });
    }
  };
  let statusText = "Active";

  if (delivary_status === "Delivarable") {
    statusText = "Not Delivarable";
  } else if (record?.[active]) {
    statusText = "In-Active";
  } else if (delivary_status === "Not Delivarable") {
    statusText = "Delivarable";
  }

  const menuItems = [
    // {
    //   key: "title",
    //   label: <b>{record?.[title]}</b>,
    //   disabled: true,
    // },
    // {
    //   type: "divider",
    // },
    {
      key: "edit",
      label: (
        <div
          className="healthsyServiceBtn healthsyStoriesColor"
          onClick={() => handleEdit(record._id)}
        >
          <img src={editIcon} alt="Edit" className="me-2" />
          <button className="healthsyStoriesColor border-0">Edit</button>
        </div>
      ),
    },
    {
      key: "delete",
      label: (
        <div
          className="healthsyServiceBtn healthsyStoriesBackgroundColor"
          onClick={onClickDelete}
        >
          <img src={deleteIcon} alt="Delete" className="me-2" />
          <button className="healthsyStoriesBackgroundColor border-0">
            Delete
          </button>
        </div>
      ),
    },
    {
      key: "toggleStatus",
      label: (
        <div
          className={`healthsyServiceBtn ${statusText === "Delivarable" || statusText === "Active" ? "healthsyStoriesinActionColor " : "healthsyStoriesActionColor"}`}
          onClick={() =>
            handleActive(
              record?._id,
              delivary_status === "Delivarable"
                ? record.delivarable
                : record?.[active],
            )
          }
        >
          <button
            className={`d-flex align-items-center gap-1 border-0 ${statusText === "Delivarable" || statusText === "Active" ? "healthsyStoriesinActionColor " : "healthsyStoriesActionColor"}`}
          >
            <div
              className={`me-2 ${
                delivary_status === "Delivarable" || record?.[active]
                  ? "healthsyServiceInActiveDot"
                  : "healthsyServiceActiveDot"
              }`}
            />
            {statusText}
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="flexRow">
      <div
        className={`${
          delivary_status === "Delivarable" || record?.[active]
            ? "healthsyServiceActvieStatus"
            : "healthsyServiceInActvieStatus"
        } flexRow`}
      >
        <div
          className={
            delivary_status === "Delivarable" || record?.[active]
              ? "healthsyServiceActive"
              : "healthsyServiceInActive"
          }
        >
          <div
            className={
              delivary_status === "Delivarable" || record?.[active]
                ? "healthsyServiceActiveDot"
                : "healthsyServiceInActiveDot"
            }
          />
          <div className="">
            {delivary_status
              ? delivary_status
              : record?.[active]
                ? "Active"
                : "In-Active"}
          </div>
        </div>

        {/* Dropdown Button */}
        <Dropdown
          className=""
          overlayClassName="actionDropdown"
          menu={{ items: menuItems }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <Button type="text" className="custom-dropdown-btn">
            <HiOutlineDotsHorizontal size={24} />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

export default StatusComponent;
